import {
  UI_CHANGE_LANGUAGE,
  OPEN_MOBILE_MENU,
  CLOSE_MOBILE_MENU
} from "./types";

export const changeLanguageMutation = language => ({
  type: UI_CHANGE_LANGUAGE,
  payload: {
    language
  }
});
export const openMobileMenu = () => ({
  type: OPEN_MOBILE_MENU
});
export const closeMobileMenu = () => ({
  type: CLOSE_MOBILE_MENU
});



// WEBPACK FOOTER //
// ./src/app/ui/store/mutations.js